import {Dispatch} from "redux"
import {connect} from "react-redux"
import {NextComponentType} from "next"

// Actions
import * as a from "../store/actions"

// Models
import {SignUpRequestDto} from "../models"
import {AppState} from "../../../store/models"

// Selectors
import {signUpStateSelector} from "../store/selectors"

export type WithSignUpProps = {
    signUp(credentials: SignUpRequestDto): void
    signingUp: boolean
    signedUp: boolean
}

export default function withSignUp(BaseComponent: NextComponentType) {
    return connect(
        (state: AppState) => signUpStateSelector(state),
        (dispatch: Dispatch) => ({
            signUp: (credentials: SignUpRequestDto) => dispatch(a.signUp(credentials)),
        }),
    )(BaseComponent)
}
